import { CatalogSummarySection } from 'app/src/features/Landing/components/CatalogSummarySection'
import { DiscountSection } from 'app/src/features/Landing/components/DiscountSection'
import { NewsCarouselSection } from 'app/src/features/Landing/components/NewsCarouselSection'
import { PartnerCarouselSection } from 'app/src/features/Landing/components/PartnerCarouselSection'
import { TimerAndBalanceSectionContainer } from 'app/src/features/Landing/components/TimerAndBalanceSecionContainer'
import { pageconfigurationsApi } from 'app/src/services/welfareportal'
import { DynamicPageWidget } from 'app/src/shared/components'
import { useWebAppContext } from 'app/src/shared/hooks'
import type { ReactElement } from 'react'
import { HomeFooterJoinSection } from './HomeFooterJoinSection'
import { HomeHeaderSection } from './HomeHeaderSection'
import { TermsSection } from './TermsSection'
import { WelfareDetailsSection } from './WelfareDetailsSection'

export function ComponentRenderer(sections?: pageconfigurationsApi.SectionItem[]): ReactElement {
  const context = useWebAppContext()
  return (
    <>
      {sections &&
        sections?.map((section) => {
          switch (section.sectionName) {
            case 'TimerAndBalanceSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <TimerAndBalanceSectionContainer {...props} />}
                  background='cardBackGround'
                  sectionItem={section}
                />
              )
            case 'HomeHeaderSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <HomeHeaderSection {...props} />}
                  sectionItem={section}
                />
              )
            case 'PartnersSection':
              return (
                <DynamicPageWidget
                  componentRenderer={(props) => <PartnerCarouselSection {...props} />}
                  key={section.sectionName}
                  sectionItem={section}
                />
              )
            case 'DiscountSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <DiscountSection {...props} />}
                  sectionItem={section}
                />
              )
            case 'CatalogSummarySection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  background='lightGrayBackground'
                  componentRenderer={(props) => <CatalogSummarySection {...props} />}
                  sectionItem={section}
                />
              )
            case 'WelfareDetailsSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <WelfareDetailsSection {...props} />}
                  sectionItem={section}
                />
              )
            case 'TermsSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <TermsSection {...props} />}
                  sectionItem={section}
                />
              )
            case 'HomeFooterJoinSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <HomeFooterJoinSection {...props} />}
                  sectionItem={section}
                />
              )
            case 'NewsCarouselSection':
              return (
                <DynamicPageWidget
                  key={section.sectionName}
                  componentRenderer={(props) => <NewsCarouselSection {...props} />}
                  sectionItem={section}
                />
              )
            default:
              if (section?.renderingMode !== 'native') {
                return <DynamicPageWidget key={section.sectionName} sectionItem={section} />
              } else {
                context.logger?.warn('Unknown Native Section', { section: section.sectionName })
                return <></>
              }
          }
        })}
    </>
  )
}
